(function () {
  var SELECTOR_TRIGGER = '[data-team-member-dialog]';
  var SELECTOR_DIALOG = 'dialog.team-member-modal';
  var SELECTOR_CLOSE = '[data-team-member-close]';
  var SELECTOR_CARD_OPEN = '.team-member-card__open';
  var CLOSE_ANIMATION_MS = 260;
  var SCROLL_LOCK_CLASS = 'team-member-modal-scroll-lock';

  function getRoot(scope) {
    return scope && scope.nodeType === 1 ? scope : document;
  }

  function markBound(node, key) {
    if (node.dataset[key] === 'true') return false;
    node.dataset[key] = 'true';
    return true;
  }

  function resetDialogState(dialog) {
    dialog.classList.remove('is-closing');
    dialog.dataset.isClosing = 'false';
  }

  function blurIfFocusable(node) {
    if (node && typeof node.blur === 'function') node.blur();
  }

  function syncBodyScrollLock() {
    var anyOpen = !!document.querySelector(SELECTOR_DIALOG + '[open]');
    if (anyOpen) {
      document.documentElement.classList.add(SCROLL_LOCK_CLASS);
      document.body.classList.add(SCROLL_LOCK_CLASS);
    } else {
      document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
      document.body.classList.remove(SCROLL_LOCK_CLASS);
    }
  }

  function animateClose(dialog) {
    if (!dialog || !dialog.open || dialog.dataset.isClosing === 'true') return;

    dialog.dataset.isClosing = 'true';
    dialog.classList.add('is-closing');

    window.setTimeout(function () {
      resetDialogState(dialog);
      dialog.close();
    }, CLOSE_ANIMATION_MS);
  }

  function bindTrigger(trigger) {
    if (!markBound(trigger, 'teamMemberDialogBound')) return;

    trigger.addEventListener('click', function () {
      var id = trigger.getAttribute('data-team-member-dialog');
      var dialog = id ? document.getElementById(id) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return;

      dialog._teamMemberTrigger = trigger;
      dialog.showModal();
      syncBodyScrollLock();
    });
  }

  function bindDialog(dialog) {
    if (!markBound(dialog, 'teamMemberModalBound')) return;

    dialog.querySelectorAll(SELECTOR_CLOSE).forEach(function (btn) {
      btn.addEventListener('click', function () {
        animateClose(dialog);
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) animateClose(dialog);
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      animateClose(dialog);
    });

    dialog.addEventListener('close', function () {
      blurIfFocusable(dialog._teamMemberTrigger);
      blurIfFocusable(document.querySelector(SELECTOR_CARD_OPEN + ':focus'));
      dialog._teamMemberTrigger = null;
      resetDialogState(dialog);
      syncBodyScrollLock();
    });
  }

  function bindDialogs(scope) {
    var root = getRoot(scope);
    root.querySelectorAll(SELECTOR_TRIGGER).forEach(bindTrigger);
    root.querySelectorAll(SELECTOR_DIALOG).forEach(bindDialog);
  }

  function init() {
    bindDialogs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindDialogs(event.target);
  });
})();
